export default "__VITE_ASSET__Mw$umg85__"